import React from "react"
import { videos } from "../components/assets/data/dummydata"
import { AiTwotoneCalendar } from "react-icons/ai"
import { YouTubeEmbed } from "react-social-media-embed"
import { useNavigate } from 'react-router-dom';
import { Typography } from "@mui/material"
import { motion } from 'framer-motion'

export const About = () => {
    const navigate = useNavigate();

  return (
    <>
      <section className='courses bg-[#F3F4F8] py-12'>
        <div className='w-4/5 m-auto md:w-11/12'>
          <div className='heading text-center mb-8'>
          <TextHighlight text="Kuppi Recordings" />
          </div>
          <div className='grid grid-cols-2 gap-8 md:grid-cols-1'>
            {videos.slice(0, 4).map((item) => (
              <div key={item.id} className='box rounded-lg shadow-lg bg-white overflow-hidden'>
                <div className='video-container'>
                  <YouTubeEmbed
                    url={item.url}
                    width="100%"
                    height="300px"
                    className='rounded-t-lg'
                  />
                </div>
                <div className='text p-4'>
                  <span className='text-[12px] bg-blue-500 text-white p-1 px-3 rounded-[5px]'>
                    {item.subject}
                  </span>
                  <Typography  className="text-black my-4 font-medium text-lg" variant="h6" sx={{ 
                      fontWeight: 600,
                      mb: 0.5,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical"
                    }}>
                      {item.title}
                    </Typography>
                  <div className='user flex items-center justify-between mt-4'>
                    <div className='flex items-center'>
                      
                    </div>
                    <div className='flex items-center text-gray-600'>
                      <AiTwotoneCalendar />
                      <span className='text-[14px] ml-2'> </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className='flex justify-center mt-8'>
            <button className='bg-transparent text-blue-500 font-semibold py-2 px-6 border border-blue-500 rounded-md' onClick={() => navigate('/youtube')}>
              Show More
            </button>
          </div>
        </div>
      </section>
    </>
  )
}


const TextHighlight = ({ text }) => {
  return (
    <h1 className="relative text-4xl font-bold mb-2 text-center">
      <span className="bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
        {text}
      </span>
      <motion.div
        className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-purple-600 to-blue-500"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.5, repeat: Infinity, repeatType: 'reverse' }}
      />
    </h1>
  )
}